import React, { useState } from 'react';
import styles from './styles.module.scss';
import DownIcon from '../../assets/down-arrow3.svg';

function CertificateItem(props) {
	const [isShown, setIsShown] = useState(false);
	return (
		<div className={styles.certificate}>
			<div className={styles.certificateInfo}>
				<li>{props.title}</li>
				{props.courseLink ? (
					<a href={props.courseLink} target='_blank' rel='noopener noreferrer'>
						{props.date}
					</a>
				) : (
					<h6>{props.date}</h6>
				)}

				{props.link ? (
					<img
						src={DownIcon}
						className={`${isShown ? styles.upArrow : styles.downArrow}`}
						alt=''
						onClick={() => setIsShown(!isShown)}
					/>
				) : null}
			</div>

			{isShown && props.link ? (
				<img
					src={require('../../assets/Certificates/' + props.link + '.jpeg')}
					alt='img'
				/>
			) : null}
		</div>
	);
}

export default CertificateItem;
